import * as React from "react";
import "../../../utils/array_extentions";
import {IStatsLocation} from "../../../config/stats";
import {getTopCompanies} from "../../../helpers/dashboard_charts_helpers";
import {useGlobalStores} from "../../../hooks/use_global_stores";
import {PieChart} from "../../Components/Charts/PieChart";

interface ICompaniesChartProps {
    locations: IStatsLocation[];
    chartHeight: number;
    showTopCompanies?: number;
}

export const LocationsChart = ({locations, chartHeight, showTopCompanies}: ICompaniesChartProps) => {
    const { currencyStore } = useGlobalStores();

    let data = locations as any;
    data = data.removeNegativeValuesFromObject('total');
    data.sortArrayOfObjectsDesc('total');

    if (showTopCompanies) {
        data = getTopCompanies(data, showTopCompanies);
    }

    return (
        <PieChart
            dataset={data.map((v: any) => ({
                value: v.total,
                label: v.name === '___NA___' ? 'Others...' : v.name,
            }))}
            size={chartHeight}
            valueFormatter={(v: any) => {
                return v.value.toCurrency(currencyStore.currentCurrency, {});
            }}
        />
    );
};
